<template>
  <div class="km__modules__logo--default">
    <ul class="km__list--modules">
      <li class="km__list__element--modules">
        <span
            v-if="showlogo_list_button"
            class="km__button--icon logolist"
            @click="openLogoList"
        >{{ $t("km_logoliste_label") }}</span>
      </li>
      <li class="km__list__element--modules">
        <button
            class="km__button--standard newlogo" type="button" name="newlogo"
            @click="openLogoLibrary">
          {{ $t("konfi_logos_logo_add") }}
        </button>
      </li>
      <li class="km__list__element--modules">
        <button
            class="km__button--icon library" type="button" name="library"
            @click="openUserLogoLibrary"
        >{{ $t("konfi_logos_bibliothek_title") }}
        </button>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import {LOGOMODULE_POSSIBLE_STATES} from "@km/components/logo/ModuleLogoAnimationStates";
import {AnimationWaitingForTargetFactory, KeyFrameTargetValues} from "@km/animations/animationFactory";
import {watch} from "vue";
import {useModuleLogoOpenStateStore} from "@km/store/frontendstate/useModuleLogoOpenState";
import globalsObject from "@k/js/globalsObject";
import {LOOPTRACKINGEVENTNAMES} from "@k/global/loopTracker";


const props = defineProps({
  showlogo_list_button: Boolean
})
const emit = defineEmits(["setOpenState"]);

const openStatusStore = useModuleLogoOpenStateStore();
const animation = AnimationWaitingForTargetFactory.getUpDownAnimation(".km__modules__logo--default");
const keyframes = new KeyFrameTargetValues(0, 100);
watch(() => openStatusStore.getVerwaltungState, newState => animation(keyframes.getTarget(newState)));
const openLogoLibrary = () => {
  globalsObject.loopTracker.trackBasicEvent(LOOPTRACKINGEVENTNAMES.KONFI_ADD_LOGO);
  emit("setOpenState", LOGOMODULE_POSSIBLE_STATES.library);
}
const openUserLogoLibrary = () => {
  globalsObject.loopTracker.trackBasicEvent(LOOPTRACKINGEVENTNAMES.KONFI_ADD_LOGO);
  emit("setOpenState", LOGOMODULE_POSSIBLE_STATES.userlibrary);
}
const openLogoList = () => emit("setOpenState", LOGOMODULE_POSSIBLE_STATES.logoList);

</script>

<style lang="scss" scoped>

/* ***********************************
*	LAYER 0: LOGO DEFAULT
*  - Buttons
*  - Buttons wrapper
*  - Layer wrapper
* ********************************** */

/* ***********************************
*	LOGO DEFAULT - Buttons
* ********************************** */
.km__button {
  &--icon {
    &.logolist {
      background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4wLjQsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojMzMzMzMzO30NCjwvc3R5bGU+DQo8Zz4NCgk8cmVjdCB4PSIzMy44IiB5PSIyOS4yIiBjbGFzcz0ic3QwIiB3aWR0aD0iNDkuNyIgaGVpZ2h0PSI2Ii8+DQo8L2c+DQo8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIyMSIgY3k9IjMyLjIiIHI9IjQuNSIvPg0KPGc+DQoJPHJlY3QgeD0iMzMuOCIgeT0iNDYuNyIgY2xhc3M9InN0MCIgd2lkdGg9IjQ5LjciIGhlaWdodD0iNi42Ii8+DQo8L2c+DQo8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSIyMSIgY3k9IjUwIiByPSI0LjUiLz4NCjxnPg0KCTxyZWN0IHg9IjMzLjgiIHk9IjY0LjUiIGNsYXNzPSJzdDAiIHdpZHRoPSI0OS43IiBoZWlnaHQ9IjYuNiIvPg0KPC9nPg0KPGNpcmNsZSBjbGFzcz0ic3QwIiBjeD0iMjEiIGN5PSI2Ny44IiByPSI0LjUiLz4NCjwvc3ZnPg0K');
      background-size: 32px;
      margin-top: 10px;
    }
  }

  &--icon {
    &.library {
      background-image: url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMi4wLjEsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iRWJlbmVfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHZpZXdCb3g9IjAgMCAxMDAgMTAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAxMDAgMTAwOyIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+DQo8c3R5bGUgdHlwZT0idGV4dC9jc3MiPg0KCS5zdDB7ZmlsbDojMzMzMzMzO30NCjwvc3R5bGU+DQo8cGF0aCBjbGFzcz0ic3QwIiBkPSJNMjQuNCw3NS42aDUxLjJjMy4xLDAsNS43LTIuNiw1LjctNS43bDAsMFYzOC42YzAtMy4xLTIuNi01LjctNS43LTUuN2wwLDBINTBsLTQtNi4xYy0xLjEtMS40LTIuNy0yLjMtNC40LTIuNA0KCUgyNC40Yy0zLjEsMC01LjcsMi42LTUuNyw1LjdWNzBDMTguOCw3My4xLDIxLjMsNzUuNiwyNC40LDc1LjZMMjQuNCw3NS42eiBNNDEuNSwzMGwzLjgsNS45YzEuMSwxLjYsMi44LDIuNiw0LjcsMi42aDI1Ljd2MzEuMw0KCUgyNC40VjMwSDQxLjV6Ii8+DQo8L3N2Zz4NCg==');
      background-size: 32px;
      margin-top: 10px;
      width: 70px;
      height: 60px;
    }
  }

  &--standard {
    &.newlogo {
      margin-top: 20px;
      height: 30px;
    }
  }
}

/* ***********************************
*	LOGO DEFAULT - Buttons wrapper
* ********************************** */
.km__modules__logo--default {
  .km__list--modules {
    display: flex;
    flex-wrap: wrap;

    .km__list__element--modules {
      &:nth-child(1) {
        width: 28%;
      }

      &:nth-child(2) {
        width: 44%;
      }

      &:nth-child(3) {
        width: 28%;
      }
    }
  }
}

/* ***********************************
*	LOGO DEFAULT - Layer wrapper
* ********************************** */
.km__modules__logo--default {
  position: fixed;
  height: 100px;
  width: 100%;
  left: 0;
  bottom: $cta-height;
  z-index: 99;
  background: $color-white;
  padding: 15px 10px 15px 0;
  transform: translate(0px, 100px);
  overflow-y: hidden;
}
</style>
